export function tabKeyEventListener(tabElements: HTMLElement[]) {
  return function (e: KeyboardEvent) {
    if (e.code === 'Tab' && tabElements.find(element => document.activeElement === element)) {
      e.preventDefault();

      const activeElement = tabElements.find(element => document.activeElement === element);
      const notDisabledElements = tabElements.filter(el => {
        return !el.classList.contains('introjs-disabled');
      });

      const targetElementIndex = e.shiftKey
        ? notDisabledElements.indexOf(activeElement) === 0
          ? notDisabledElements.length - 1
          : notDisabledElements.indexOf(activeElement) - 1
        : notDisabledElements.indexOf(activeElement) === notDisabledElements.length - 1
          ? 0
          : notDisabledElements.indexOf(activeElement) + 1;
      const targetElement = notDisabledElements[targetElementIndex];
      return targetElement.focus();
    }
  };
}
